<hs-card [expandable]="true" [collapsed]="collapsed()" [hsLayer]="'one'">
  <hs-card-header>
    <svg
      hsCardAvatar
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fit=""
      preserveAspectRatio="xMidYMid meet"
      focusable="false"
      [height]="32"
      [width]="32"
    >
      <path
        d="M416 320H96c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-128C448 334.3 433.7 320 416 320zM416 480H96v-128h320V480zM448 192V70.63C448 62.14 444.6 54 438.6 48l-38.63-38.63C393.1 3.37 385.9 0 377.4 0H128C92.65 0 64 28.65 64 64v128C28.7 192 0 220.7 0 256v112C0 376.8 7.156 384 16 384S32 376.8 32 368V256c0-17.67 14.33-32 32-32h384c17.67 0 32 14.33 32 32v112c0 8.844 7.156 16 16 16s16-7.156 16-16V256C512 220.7 483.3 192 448 192zM416 192H96V64c0-17.67 14.33-32 32-32h249.4L416 70.63V192zM432 248c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24C456 258.7 445.3 248 432 248z"
      ></path>
    </svg>
    <div hsCardTitle>Drucktexte</div>
  </hs-card-header>
  <hs-card-body>
    <hs-form-field [hidden]="!showTitle()">
      <hs-form-label>Überschrift</hs-form-label>
      <input
        hsInput
        [placeholder]="'Überschrift'"
        [disabled]="!editable()"
        [value]="title()"
        (input)="onTitleChanged($event.target.value)"
      />
    </hs-form-field>

    <hs-form-field [hidden]="!showHeader()">
      <hs-form-label>Kopfzeile, ab 2. Seite</hs-form-label>
      <textarea
        hsInput
        [placeholder]="'Kopfzeile, ab 2. Seite'"
        class="min-h-25"
        [disabled]="!editable()"
        [value]="header()"
        (input)="onHeaderChanged($any($event.target).value)"
      ></textarea>
    </hs-form-field>

    <hs-form-field [hidden]="!showPreText()">
      <hs-form-label>Vortext auf 1. Seite</hs-form-label>
      <textarea
        hsInput
        [placeholder]="'Vortext auf 1. Seite'"
        class="min-h-25"
        [disabled]="!editable()"
        [value]="preText()"
        (input)="onPreTextChanged($any($event.target).value)"
      ></textarea>
    </hs-form-field>

    <hs-form-field [hidden]="!showPostText()">
      <hs-form-label>Nachtext auf letzter Seite</hs-form-label>
      <textarea
        hsInput
        [placeholder]="'Nachtext auf letzter Seite'"
        class="min-h-25"
        [disabled]="!editable()"
        [value]="postText()"
        (input)="onPostTextChanged($any($event.target).value)"
      ></textarea>
    </hs-form-field>

    <hs-form-field [hidden]="!showFooter()">
      <hs-form-label>Fußzeile auf jeder Seite</hs-form-label>
      <textarea
        hsInput
        [placeholder]="'Fußzeile auf jeder Seite'"
        class="min-h-25"
        [disabled]="!editable()"
        [value]="footer()"
        (input)="onFooterChanged($any($event.target).value)"
      ></textarea>
    </hs-form-field>
  </hs-card-body>
</hs-card>
